import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
  name: 'referenceTitle',
  pure: false
})

export class ReferenceTitlePipe implements PipeTransform {

  transform(value: any, replaceText?: string): any {
    if (typeof value === 'undefined' || value === 'null' || value === null || value === undefined || value?.length === 0) {
      return value;
    } else {
      if (value.length > 36) {
        return value.substring(0, 30) + '...' + value.substring(value.length - 3, value.length);
      } else {
        return value;
      }
    }
  }
}
